import React from "react";
import { MaintainanceRequestListsScreenContainer } from "src/containers";

export const MaintainanceRequestListsScreen = () => {
  return <MaintainanceRequestListsScreenContainer />;
};
